import { InjectionToken } from '@angular/core';
import type * as nconf from 'nconf';

export const NCONF: InjectionToken<ConfType> = new InjectionToken<ConfType>('NCONF');

export type ConfType = nconf.Provider;
